import React, { Fragment } from "react";

class Button3 extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="text-center p-5">
          <a href="https://tangled.ae/Spellbound-Robot/entry.php?val=3">
            <button type="button" className="btn-lg btn-danger">
              Right
            </button>
          </a>
        </div>
      </Fragment>
    );
  }
}

export default Button3;
